import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Recaptcha from 'react-google-recaptcha';
import Router from '../../../../router';
import { Button } from '@mui/material';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// Styles
import {
  Container,
  Form,
  Title,
  Subtitle,
  SectionRow,
  SectionInput,
  ContainerInput,
  Input,
  Span,
  SpanLink,
  SectionBtn,
  LabelCustom,
  MicrosoftContainer,
  ImageContainer,
} from './styles'

import { useTranslation } from 'react-i18next'
import { ColorsContext } from "../../../../Context/ColorsContext"

const CORPORATE_DOMAINS = ['@cenit-transporte.com', '@ecopetrol.com.co', '@odl.com.co'];

export const LoginForm = ({
  form,
  setForm,
  messageError,
  handleChange,
  handleSubmit,
  isLoading,
  recaptchaRef,
  setMessageError,
  setIsLoading,
  setOpen,
  handleMicrosoftLogin,
}) => {

  const { t } = useTranslation();
  const { colors } = React.useContext(ColorsContext);
  const [showPassword, setShowPassword] = React.useState(false);
  const [useMicrosoftAccount, setUseMicrosoftAccount] = useState(false);
  const [manualOverride, setManualOverride] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
    event.persist();

    setTimeout(() => {
      handleClickShowPassword();
    }, 0);
  };

  const handleRecaptchaVerify = (response) => {
    setForm(prev => ({ ...prev, reCaptchaToken: response }))
  };

  useEffect(() => {
    if (manualOverride) return;
    const isCorporate = CORPORATE_DOMAINS.some(d =>
      form.username.toLowerCase().endsWith(d)
    );
    setUseMicrosoftAccount(isCorporate);
  }, [form.username, manualOverride]);

  const handleSwitchChange = (e) => {
    setManualOverride(true);
    setUseMicrosoftAccount(e.target.checked);
    setMessageError('');
  };

  const handleSingleStepLogin = async () => {
    setIsLoading(true);
    if (useMicrosoftAccount) {
      setIsLoading(false);
      handleMicrosoftLogin();
      return;
    }
    await handleSubmit();
    setIsLoading(false);
  };

  const getLoginIcon = () => {

    if (colors?.loginIconUrl === null || colors?.loginIconUrl === undefined || colors?.loginIconUrl === "") {
      return (
        <img src='cenit-logo.png' width={250} alt='logo' />
      )
    }

    return (colors?.loginIconUrl !== null && colors?.loginIconUrl !== "" && colors?.loginIconUrl !== undefined) ?
      <img src={`${Router.apiBaseUrl}/${colors.loginIconUrl.toString()}`} width={250} alt='logo' />
      : null
  }

  return (
    <Container>
      <Form>
        <ImageContainer>{getLoginIcon()}</ImageContainer>
        <Title>{(colors?.title !== null && colors?.title !== "" && colors?.title !== undefined ? colors.title : t('login.titleApp'))}</Title>
        <Subtitle>{t('login.title')}</Subtitle>

        {/* Campo usuario */}
        <SectionRow>
          <SectionInput>
            <LabelCustom>{t('login.user')}:</LabelCustom>
            <ContainerInput>
              <Input
                name='username'
                value={form.username}
                onChange={(e) => { handleChange(e, 'username'); setMessageError(''); setManualOverride(false); }}
                required
              />
            </ContainerInput>
          </SectionInput>
        </SectionRow>

        <SectionRow>
          <SectionInput>
            <Span>{messageError}</Span>
          </SectionInput>
        </SectionRow>

        {/* Recuadro Microsoft */}
        <SectionRow>
          <MicrosoftContainer>

            {/* Encabezado: texto + switch */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography sx={{ fontWeight: 'bold', color: '#000', fontSize: '14px' }}>
                {t('login.useMicrosoftAccount')}
              </Typography>
              <Switch
                checked={useMicrosoftAccount}
                onChange={handleSwitchChange}
                size="small"
              />
            </div>

            {/* Contenido condicional */}
            {useMicrosoftAccount ? (
              <Typography sx={{
                fontSize: '12px',
                color: '#9e9e9e',
                mt: 0.5,
                pr: '48px',
              }}>
                {t('login.microsoftRedirectMessage')}
              </Typography>
            ) : (
              <>
                <Divider sx={{ my: 1, color: '#e0e0e0', opacity: 1 }}/>

                {/* Campo contraseña */}
                <SectionRow>
                  <SectionInput bottom>
                    <LabelCustom>{t('login.password')}:</LabelCustom>
                    <ContainerInput>
                      <Input
                        name='password'
                        value={form.password}
                        onChange={(e) => { handleChange(e, 'password'); setMessageError(''); setManualOverride(false); }}
                        required
                        type={showPassword ? 'text' : 'password'}
                      />
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    </ContainerInput>
                  </SectionInput>
                </SectionRow>

                {/* Captcha */}
                {process.env.REACT_APP_CAPTCHA !== undefined && (
                  <SectionRow>
                    <div style={{ margin: '0 auto', marginTop: '1rem' }}>
                      <Recaptcha
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_CAPTCHA}
                        onChange={handleRecaptchaVerify}
                      />
                    </div>
                  </SectionRow>
                )}

                {/* Olvidaste la contraseña */}
                <SectionRow>
                  <Link to={Router.appPasswordRecovery} state={{ user: form.username }}>
                    <SpanLink>{t('login.forgotPassword')}</SpanLink>
                  </Link>
                </SectionRow>
              </>
            )}
          </MicrosoftContainer>
        </SectionRow>

        {/* Botón Iniciar sesión */}
        <SectionBtn>
          <Button
            variant="contained"
            sx={{
              color: colors.white,
              backgroundColor: colors.buttonActionColor,
              cursor: 'pointer',
              padding: '.5em 2em',
              borderRadius: '5px',
              display: 'inline-block',
              justifyContent: 'center',
              transition: 'all .3s ease-in-out',
              width: '30%',
              "&.MuiButton-outlined.Mui-disabled": {
                background: colors.grayGraphic,
                cursor: 'not-allowed',
              },
              "&:hover": {
                backgroundColor: colors.buttonActionColor,
                opacity: 0.8,
                color: colors.white,
                transition: 'all .3s ease',
              },
              '&:active': {
                transition: 'all .3s ease',
                opacity: '1',
              },
            }}
            onClick={handleSingleStepLogin}
            disabled={
              isLoading ||
              (!useMicrosoftAccount && (form.reCaptchaToken === null || form.password === ''))
            }
          >
            {useMicrosoftAccount ? t('login.continue') : t('login.loginButton')}
          </Button>
        </SectionBtn>

      </Form>
    </Container>
  )
}
